import { useState, useLayoutEffect, useEffect } from 'react';

const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
const useWindowSize = () => {
  const isClient = typeof window !== "undefined";
  const getSize = () => ({
    width: isClient ? window.innerWidth : 0,
    height: isClient ? window.innerHeight : 0
  });
  const [windowSize, setWindowSize] = useState(getSize);
  const [breakpoints, setBreakpoints] = useState({
    isMobile: false,
    isSmallTablet: false,
    isTablet: false,
    isDesktop: false
  });
  useIsomorphicLayoutEffect(() => {
    if (!isClient) return;
    const handleResize = () => {
      const width = window.innerWidth || document.documentElement.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight;
      setWindowSize({ width, height });
      setBreakpoints({
        isMobile: width < 768,
        isSmallTablet: width >= 768 && width <= 991,
        isTablet: width >= 768 && width <= 1024,
        isDesktop: width > 1024
      });
    };
    handleResize();
    requestAnimationFrame(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    });
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isClient]);
  return {
    windowSize,
    ...breakpoints
  };
};

export { useWindowSize };
//# sourceMappingURL=useWindowSize.js.map
